import { render, staticRenderFns } from "./NotificationResult.vue?vue&type=template&id=01c165ac&scoped=true"
import script from "./NotificationResult.vue?vue&type=script&lang=js"
export * from "./NotificationResult.vue?vue&type=script&lang=js"
import style0 from "./NotificationResult.vue?vue&type=style&index=0&id=01c165ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c165ac",
  null
  
)

export default component.exports